import { setHours, setMinutes } from 'date-fns'

export const concatDateAndTime = (date: Date, time: string) => {
  const [hours, minutes] = time.split(':').map(Number) as [number, number]
  return setMinutes(setHours(date, hours), minutes)
}
